<template>
    <div>
        <div class="clearfix company-form-container company-form-container-warapper">
            <div class="company-form-container-title-wrapper">
                <div class="col-sm-12 px-3 company-form-box-title">{{this.list_title}}</div>
            </div>
            <div class="col-md-12 company-form-container-content-wrapper">

                <b-overlay :show="application_loading" rounded="sm">
                    <table class="employee-list-table dataTable table-overflow table-sticky ess-custom-table" > 
                        <thead class="" style="">
                            <tr class="table-head">
                                <td class="" v-for="column in columns" :key="column.name" @click="sortBy(column.name)" :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" style="cursor:pointer;"> <label class="custom-label"><span>{{column.label}}</span></label>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(emp_application , n) in paginatedData">
                            <tr class="table-row hover-bg">
                                <td class="text-center">{{emp_application.date_added}}</td>
                                <td class="text-right">{{formatMoney(emp_application.amount)}}</td>
                                <td class="text-center">{{emp_application.type}}</td>
                                <td class="text-center">{{emp_application.details}}</td>
                                <td class="text-center">{{emp_application.processor_name}}</td>
                            </tr>
                            </template>
                        </tbody>
                    </table>

                    
                    <div v-if="paginatedData.length == 0" class="mb-3 list-no-data">
                        No records found.
                    </div>
                    
                    <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                        <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">                
                            <ul class="pagination b-pagination float-left mb-0 mt-1">
                                <li class="page-item disabled m-2">View</li>
                                <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                            </ul>
                            <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                        </div>
                    
                    </div>
                    
                </b-overlay>
                <!-- <table class="table border-0"> 
                    <thead>
                        <tr class="table-head">
                            <th class="border-0 align-top text-center"><label class="mb-0">Date</label></th>                        
                            <th class="border-0 align-top text-center"><label class="mb-0">Amount (BDT)</label></th>
                            <th class="border-0 align-top text-center"><label class="mb-0">Distribution Type</label></th>
                            <th class="border-0 align-top text-center"><label class="mb-0">Details</label></th>
                            <th class="border-0 align-top text-center"><label class="mb-0">Processed By</label></th>
                        </tr>
                    </thead>

                    
                    <tbody>
                        <tr class="table-row hover-bg" v-for="(emp_application,index) in application_lists" :key="emp_application.id">
                            
                            
                            
                        </tr>
                        <tr v-if="application_lists.length == 0"><td :colspan=8>Currently no application available!</td></tr>
                    </tbody>
                    <tfoot v-if="application_lists.length != 0">
                    <tr>

                    </tr>
                    </tfoot>
                </table> -->
                
            </div>
        </div>
    </div>
</template>
<script>
 
    export default{
        mounted() {
            //if(this.employeedata.last_working_day == '0000-00-00')
                //this.fdata.last_working_day = '';
            
            this.showoverlay = false;
        },
        props: ['readonly','pageurl','distribution_type','pf_settings'],
        data(){            
            let sortOrders = {};
            let columns = [
                            {label: 'Date', name: 'date_added' },
                            {label: 'Amount (BDT)', name: 'amount'},
                            {label: 'Distribution Type', name: 'type'},
                            {label: 'Details', name: 'details'},
                            {label: 'Processed By', name: 'processor_name'},
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});
            
            return {

                /* start pf signup variables */
                showoverlay : true,
                per_page:10,
                application_lists: [],
                application_loading : false,
                employeesearch:{name:''},
                users : [], 
                eligible_pf: 0,
                chosen_emp_id: 0,
                c_flg: 0, // This variable is for reloading public info
                list_title:'',
                loading:'',
                mark_flag:0,
                statusOptions : [
                    { id: 0, text: "Archived" },
                    { id: 1, text: "Draft" },
                    { id: 2, text: "Audited" },
                ],
                approvepass: '',
                incorrectpass: '',
                payrun_delete_msg:'',
                btn_name:'',
                loading:'',
                /** Sohel Code Starts Here */
                showoverlay_list:false,
                columns: columns,
                sortKey: 'date_added',
                sortOrders: sortOrders,           
                length: 20,
                pagination: {currentPage: 1, pages:1}, 
                temp_length: 20,
                length_options: [],
                people:0,    
                /** Sohel Code Ends Here */

            }
        },
        methods:{
            getDistributionList: function()
            {

                this.application_loading = true;
            
                axios.get(this.$api_url+'/pf/distribution/list' , {
                    params: {
                        distribution_type:this.distribution_type
                    }
                }).then(function(response){
                if(response.data){
                this.application_lists = response.data;
                this.people = this.application_lists.length;
                this.length_options = [{ value: 20, text: "20" },
                                            { value: 50, text: "50" },
                                            { value: 100, text: "100" }
                                        ]; 
                }else{
                this.application_lists = [];
                }
                
                this.application_loading = false;
            
                }.bind(this));
            },
            showDeleteModal: function(pageflg)
            {   
                //this.loading = 'true';
                this.distribution_id=pageflg;
                //this.$bvModal.show('delete-modal');
                this.approvepass="";
                this.$bvModal.show('delete-payrun-modal');
                this.payrun_delete_msg="Are you sure to delete this distribution ?";
                this.btn_name="Delete";
            },

            showConfirmModal: function(pageflg,flag)
            {   
                //this.loading = 'true';
                this.mark_flag = flag;
                this.distribution_id=pageflg;
                //this.$bvModal.show('confirm-modal');
                this.approvepass="";
                if(flag==2)
                {
                    this.payrun_delete_msg="Are you sure to mark this distribution as Audited ?";
                    this.btn_name="Mark as Audited";
                }
                if(flag==1)
                {
                    this.payrun_delete_msg="Are you sure to mark this distribution as Draft ?";
                    this.btn_name="Mark as Draft";
                }
                
                this.$bvModal.show('confirm-payrun-modal');
            },
            updateDistribution:function(pageflg)
            {
               

                this.loading='load';
              
                let formData = new FormData();
                formData.append('distribution_id', pageflg); 
                formData.append('status', this.mark_flag); 
               
                if(this.approvepass!='')
                 {
                     var pass=this.approvepass;  
    			     this.loading='load';
                     formData.append('pass',pass);
                 }
                 
               
                axios.post(this.$api_url+'/pf/distribution/update', formData) 
                    .then(function (response) 
                    {    

                        this.loading='';
                        this.$bvModal.hide('confirm-payrun-modal');
                        this.loan_entity_id=''; 
                        this.loan_update_status = '';
                        this.loading='';   
                        this.getDistributionList();
                        if(response.data.success == true)
                        {
                            this.$bvToast.toast('Success!', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });
                        }
                        else
                        {
                            this.$bvToast.toast(response.data.message, {
                                title: `error`,
                                variant: 'danger',
                                solid: true
                            });
  
                        }
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
            },

            deleteDistribution:function(pageflg)
            {
               

                this.loading='load';
              
                let formData = new FormData();
                formData.append('distribution_id', pageflg); 
                if(this.approvepass!='')
                 {
                     var pass=this.approvepass;  
    			     this.loading='load';
                     formData.append('pass',pass);
                 }
                 
               
                axios.post(this.$api_url+'/pf/distribution/delete', formData) 
                    .then(function (response) 
                    {    

                        this.loading='';
                        this.$bvModal.hide('delete-payrun-modal');
                        this.loan_entity_id=''; 
                        this.loan_update_status = '';
                        this.loading='';   
                        this.getDistributionList();
                        if(response.data.success == true)
                        {
                            this.$bvToast.toast('Success!', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });
                        }
                        else
                        {
                            this.$bvToast.toast(response.data.message, {
                                title: `error`,
                                variant: 'danger',
                                solid: true
                            });

                        }
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
            },
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }
                
            //     return money;
            // },  
             
            
        },
        created: function(){
            if(this.distribution_type==1)
            {
                this.list_title = 'Company Profit Distribution List';
            }
            else if(this.distribution_type==2)
            {
                this.list_title = 'Company Forfeiture Distribution List';
            }
            else if(this.distribution_type==3)
            {
                this.list_title = 'Company Forfeiture Reclaim List';
            }
            this.getDistributionList();

        },
        
        computed: 
        {
            filteredData() 
            {
                let filtered_list = this.application_lists;
                if (this.search) 
                {
                  
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                
                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";                
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey) 
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {
                            let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type === 'date') 
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            } 
                            else if (this.columns[index].type && this.columns[index].type === 'number') 
                            {
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            } 
                            else 
                            {
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }
                
                return filtered_list;
            },
            paginatedData() 
            {     
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },

            fetchStartWeekday()
            {
                return this.week_start_day;
            },
        }

    }

</script>


<style scoped>
.distribution_delete_show.show {
	position: relative !important;
}
.distribution_delete_show .dropdown-menu.action-dropdown-menu.show {
	top: 0 !important;
}

</style>